import { cx } from 'utils';

/**
 * Badge — compact status / category label. Used by PageHeader, cards, lists.
 *
 * @param {'brand'|'teal'|'cyan'|'gold'|'neutral'|'success'|'warning'|'danger'|'booked'|'live'|'premium'} [variant='brand']
 * @param {boolean} [dot=false]  Render a leading status dot.
 */
const VARIANTS = {
  brand: 'bg-brand-50 text-brand-700 ring-brand-100',
  teal: 'bg-teal-50 text-teal-700 ring-teal-200',
  cyan: 'bg-teal-50 text-teal-700 ring-teal-200',
  gold: 'bg-gold-50 text-gold-700 ring-gold-200',
  neutral: 'bg-slate-100 text-slate-600 ring-slate-200',
  success: 'bg-success-50 text-success-700 ring-success-100',
  warning: 'bg-gold-50 text-gold-700 ring-gold-200',
  danger: 'bg-red-50 text-red-700 ring-red-200',
  // PDF status pills.
  booked: 'bg-brand-50 text-brand-700 ring-brand-100', // soft indigo "Booked"
  live: 'bg-teal-50 text-teal-700 ring-teal-200', // sky-blue "Live"
  premium: 'bg-gold-50 text-gold-700 ring-gold-200', // gold "Premium"
};

const DOTS = {
  brand: 'bg-brand-500',
  teal: 'bg-teal-500',
  cyan: 'bg-teal-500',
  gold: 'bg-gold-500',
  neutral: 'bg-slate-400',
  success: 'bg-success',
  warning: 'bg-gold-500',
  danger: 'bg-danger',
  booked: 'bg-brand-500',
  live: 'bg-teal-500',
  premium: 'bg-gold-500',
};

export default function Badge({ variant = 'brand', dot = false, className = '', children, ...props }) {
  return (
    <span
      className={cx(
        // nowrap: a status chip squeezed by a table column broke "Mentor no-show"
        // into two lines; a chip is a single label and never wraps.
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset',
        VARIANTS[variant] || VARIANTS.brand,
        className
      )}
      {...props}
    >
      {dot && <span className={cx('h-1.5 w-1.5 rounded-full', DOTS[variant] || DOTS.brand)} />}
      {children}
    </span>
  );
}
